export type SupportedLanguage = 'en' | 'zh' | 'ko' | 'ar';

export type PlanKey = 'monthly' | 'halfYear' | 'yearly';

interface PlanTranslation {
  name: string;
  period: string;
  features: string[];
}

interface PricingTranslation {
  heading: string;
  choosePlan: string;
  languageLabel: string;
  currencySymbol: string;
  plans: Record<PlanKey, PlanTranslation>;
}

export const planOrder: PlanKey[] = ['monthly', 'halfYear', 'yearly'];

export const languageOptions: Array<{ code: SupportedLanguage; label: string }> = [
  { code: 'en', label: 'English' },
  { code: 'zh', label: '中文' },
  { code: 'ko', label: '한국어' },
  { code: 'ar', label: 'العربية' },
];

export const pricingTranslations: Record<SupportedLanguage, PricingTranslation> = {
  en: {
    heading: 'Our Pricing',
    choosePlan: 'Choose Plan',
    languageLabel: 'Language',
    currencySymbol: '$',
    plans: {
      monthly: {
        name: 'Monthly',
        period: 'month',
        features: ['5 Mock Tests per Day', 'Class Mode or Exam Mode'],
      },
      halfYear: {
        name: '6-Month',
        period: '6 months',
        features: ['7 Mock Tests per Day', 'Class Mode or Exam Mode', 'Save 10%'],
      },
      yearly: {
        name: 'Yearly',
        period: 'year',
        features: ['10 Mock Tests per Day', 'Class Mode or Exam Mode', 'Save 20%'],
      },
    },
  },
  zh: {
    heading: '价格方案',
    choosePlan: '选择方案',
    languageLabel: '语言',
    currencySymbol: '¥',
    plans: {
      monthly: {
        name: '月度计划',
        period: '每月',
        features: ['每天 5 次模拟考试', '课堂模式或考试模式'],
      },
      halfYear: {
        name: '半年计划',
        period: '6 个月',
        features: ['每天 7 次模拟考试', '课堂模式或考试模式', '节省 10%'],
      },
      yearly: {
        name: '年度计划',
        period: '每年',
        features: ['每天 10 次模拟考试', '课堂模式或考试模式', '节省 20%'],
      },
    },
  },
  ko: {
    heading: '이용 요금제',
    choosePlan: '요금제 선택',
    languageLabel: '언어',
    currencySymbol: '₩',
    plans: {
      monthly: {
        name: '월간 요금제',
        period: '월',
        features: ['하루 5회 모의고사', '수업 모드 또는 시험 모드'],
      },
      halfYear: {
        name: '6개월 요금제',
        period: '6개월',
        features: ['하루 7회 모의고사', '수업 모드 또는 시험 모드', '10% 할인'],
      },
      yearly: {
        name: '연간 요금제',
        period: '연',
        features: ['하루 10회 모의고사', '수업 모드 또는 시험 모드', '20% 할인'],
      },
    },
  },
  ar: {
    heading: 'الباقات المتاحة',
    choosePlan: 'اختر الباقة',
    languageLabel: 'اللغة',
    currencySymbol: '$',
    plans: {
      monthly: {
        name: 'شهري',
        period: 'شهري',
        features: ['5 اختبارات تجريبية يومياً', 'وضع الدرس أو وضع الامتحان'],
      },
      halfYear: {
        name: 'نصف سنوي',
        period: 'كل 6 أشهر',
        features: ['7 اختبارات تجريبية يومياً', 'وضع الدرس أو وضع الامتحان', 'وفّر 10%'],
      },
      yearly: {
        name: 'سنوي',
        period: 'سنوي',
        features: ['10 اختبارات تجريبية يومياً', 'وضع الدرس أو وضع الامتحان', 'وفّر 20%'],
      },
    },
  },
};
